import { useState, useEffect } from 'react'
import AssemblySearchResultsGrid from './Components/GridComponents/AssemblySearchResultsGrid'
import styles from './AssemblySearch.module.scss'
import useAgent from './Hook/useAgent'
import {
    aggregates,
    pageDataState,
    useDashboardContext,
} from './Context/AssemblySearchResultsContext'
import { ToggleButtons } from '../GlobalComponents/Inputs/Inputs'
import {
    createAppState,
    processWithGroups,
    sortData,
} from './Components/GridComponents/AssemblySearchGridFunctions'
import { setExpandedState } from '@progress/kendo-react-data-tools'
import AssemblySearchInput from './Components/AssemblySearchInput'
import { DropDownList } from '@progress/kendo-react-dropdowns'

export default function AssemblySearchResults() {
    enum DATE_RANGE {
        'All' = 0,
        'PastYear' = 1,
    }

    const { setDataAvailable, setAppState, setDataState, setCollapsedState, setOperationsResult } =
        useDashboardContext()

    const [searchResults, setSearchResults] = useState<AssemblySearchResult[] | undefined>([])
    const { agent } = useAgent<AssemblySearchResult>()

    const [dateRange, setDateRange] = useState<DATE_RANGE>(1)
    const [searchCriteria, setSearchCriteria] = useState<string>()

    useEffect(() => {
        document.getElementsByTagName('html')[0].classList.add(styles.AssemblySearch)
    }, [])

    useEffect(() => {
        if (!searchCriteria) return

        const getData = async () => {
            const responseList = await agent.Assemblies.list(dateRange, searchCriteria)
            if (responseList) {
                const sortedData = sortData(responseList)
                setSearchResults(sortedData)
            }
        }
        getData()
    }, [searchCriteria, dateRange])

    useEffect(() => {
        if (searchResults) {
            setDataAvailable(searchResults)
            setDataState(pageDataState)
            setCollapsedState([])
            const operations = processWithGroups(
                searchResults ? searchResults : [],
                pageDataState,
                aggregates
            )
            setOperationsResult(operations)
            const data = setExpandedState({
                data: operations.data,
                collapsedIds: [],
            })

            const result = createAppState(0, 10, data)
            setAppState(result)
        }
    }, [searchResults])

    return (
        <>
            <div className={styles.AssemblySearch}>
                <AssemblySearchInput onSearch={setSearchCriteria} />
                {searchCriteria &&
                    (agent.Assemblies.loading ? (
                        <>
                            <div
                                className={'k-i-loading'}
                                style={{
                                    fontSize: 200,
                                    position: 'fixed',
                                    top: '50%',
                                    right: '50%',
                                }}
                            ></div>
                        </>
                    ) : (
                        <>
                            <div className={styles.AssemblySearchResults}>
                                <div className={styles.AssemblySearchResultsHeader}>
                                    <span
                                        style={{
                                            textAlign: 'right',
                                            marginRight: '1em',
                                        }}
                                    >
                                        Assemblies Displayed:
                                    </span>
                                    <ToggleButtons
                                        buttonText={['Show All', 'Past Year']}
                                        selectedIndex={dateRange}
                                        onChange={(newSelectedIndex) =>
                                            setDateRange(newSelectedIndex)
                                        }
                                    />
                                </div>
                                {searchResults && searchResults.length > 0 ? (
                                    <div className={styles.AssemblySearchTable}>
                                        <AssemblySearchResultsGrid />
                                    </div>
                                ) : (
                                    <div className={styles.AssemblySearchNoResultsFound}>
                                        No results found
                                    </div>
                                )}
                            </div>
                        </>
                    ))}
            </div>
        </>
    )
}
